import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../utils/axios";
import "./EventsPage.css";

const EventPage = () => {
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [userRole, setUserRole] = useState(null);
    const [showOlderEvents, setShowOlderEvents] = useState(false);

    const decodeJWT = (token) => {
        try {
            const base64Url = token.split('.')[1];
            const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
            const jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            }).join(''));
            return JSON.parse(jsonPayload);
        } catch (error) {
            console.error('Error decoding JWT:', error);
            return null;
        }
    };

    const parseDate = (dateString) => {
        if (!dateString) return null;
        const [datePart, timePart] = dateString.split(' ');
        const [day, month, year] = datePart.split('.');
        const [hour, minute] = timePart.split(':');
        return new Date(year, month - 1, day, hour, minute);
    };

    const getCostForRole = (event) => {
        if (!userRole || !event) {
            return event?.cost || null;
        }

        const role = userRole.toLowerCase();
        switch (role) {
            case "ksv!":
                return event.costKsv !== null && event.costKsv !== undefined ? event.costKsv : event.cost;
            case "külaline":
                return event.costKulaline !== null && event.costKulaline !== undefined ? event.costKulaline : event.cost;
            case "vil!":
                return event.costVil !== null && event.costVil !== undefined ? event.costVil : event.cost;
            case "noorliige":
                return event.costEiorliige !== null && event.costEiorliige !== undefined ? event.costEiorliige : event.cost;
            default:
                return event.cost;
        }
    };

    useEffect(() => {
        const token = localStorage.getItem("authToken");
        setIsLoggedIn(!!token);
        if (token) {
            const decoded = decodeJWT(token);
            if (decoded && decoded.role) {
                setUserRole(decoded.role);
            }
        }
    }, []);

    useEffect(() => {
        axiosInstance
            .get("/api/events")
            .then((response) => {
                const events = Array.isArray(response.data) ? response.data : [];
                const sortedEvents = events.sort((a, b) => {
                    const dateA = parseDate(a.startTime) || new Date(0);
                    const dateB = parseDate(b.startTime) || new Date(0);
                    return dateA - dateB;
                });
                setData(sortedEvents);
                setLoading(false);
            })
            .catch((err) => {
                console.error("Viga ürituste laadimisel:", err);
                setError(err.message || "Ürituste laadimine ebaõnnestus");
                setLoading(false);
                setData([]);
            });
    }, []);

    if (loading) return <div>Laadimine...</div>;
    if (error) return <div>Viga: {error}</div>;

    const now = new Date();
    const twoDaysAgo = new Date(now.getTime() - 2 * 24 * 60 * 60 * 1000);
    
    const filteredData = showOlderEvents 
        ? data 
        : data.filter(event => {
            const endTime = parseDate(event.endTime);
            if (!endTime) return true;
            return endTime >= twoDaysAgo;
        });

    return (
        <div className="events-container">
            <div className="events-header">
                <h1>Üritused</h1>
                <button 
                    onClick={() => setShowOlderEvents(!showOlderEvents)}
                    className="older-events-button"
                >
                    {showOlderEvents ? 'Peida varasemad sündmused' : 'Näita ka varasemaid üritusi'}
                </button>
            </div>
            <div className="events-list" aria-label="Ürituste nimekiri">
                <table>
                    <thead>
                        <tr>
                            <th>Algus</th>
                            <th>Lõpp</th>
                            <th>Nimetus</th>
                            <th>Osalustasu</th>
                            <th>Osalejate arv</th>
                        </tr>
                    </thead>
                    <tbody>
                        {Array.isArray(filteredData) && filteredData.length > 0 ? (
                            filteredData.map((post) => (
                            <tr key={post.id}>
                                <td>{post.startTime}</td>
                                <td>{post.endTime}</td>
                                <td>
                                    <span
                                        className="event-title-link"
                                        onClick={() => navigate(`/events/${post.id}`)}
                                    >
                                        {post.name}
                                    </span>
                                </td>
                                <td>
                                    {(() => {
                                        if (!isLoggedIn) {
                                            return 'Hinna nägemiseks logi sisse';
                                        }
                                        const cost = getCostForRole(post);
                                        if (cost !== null && cost !== undefined && cost > 0) {
                                            return `€${cost.toFixed(2)}`;
                                        }
                                        if (userRole && userRole.toLowerCase() === 'noorliige') {
                                            return 'Tasuta';
                                        }
                                        return '€0.00';
                                    })()}
                                </td>
                                <td>
                                    {(() => {
                                        const total = (post.users?.length || 0) + (post.guests?.length || 0);
                                        return post.participantLimit ? `${total}/${post.participantLimit}` : total;
                                    })()}
                                </td>
                            </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan={isLoggedIn ? "6" : "5"} style={{ textAlign: 'center' }}>Tulevased üritused puuduvad</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default EventPage;